var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "SystemDialog",
        {
          attrs: {
            persistent: "",
            "max-width": 500,
            title: _vm.showBtn ? _vm.$t("tip_mod[0]") : _vm.$t("tip_mod[1]"),
            "show-close": !!(_vm.formData && _vm.formData.canSkip),
            "actions-align": "center",
          },
          on: { close: _vm.close },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _vm.formData && _vm.formData.canSkip
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "text-none",
                          attrs: {
                            depressed: "",
                            small: "",
                            color: "primary",
                            outlined: "",
                          },
                          on: { click: _vm.close },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("button.cancel")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.showBtn && _vm.firstStep
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "text-none",
                          attrs: { depressed: "", small: "", color: "primary" },
                          on: { click: _vm.handleNext },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("button.next")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.showBtn || !_vm.firstStep
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "text-none",
                          attrs: {
                            depressed: "",
                            small: "",
                            color: "primary",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.ok },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("button.submit")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _vm.showBtn
            ? _c("p", { staticClass: "system-dialog__tip" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.firstStep
                        ? _vm.$t("tip_mod[2]")
                        : _vm.$t("tip_mod[3]", [_vm.realPhone])
                    ) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          !_vm.showBtn
            ? _c("v-form", { ref: "form_old" }, [
                _c(
                  "div",
                  { staticClass: "system-dialog__field" },
                  [
                    _c(
                      "div",
                      { staticClass: "system-dialog__label" },
                      [
                        _c("RequiredDot", [
                          _vm._v(_vm._s(_vm.$t("old_phone[0]"))),
                        ]),
                      ],
                      1
                    ),
                    _c("v-text-field", {
                      staticClass: "system-dialog__input",
                      attrs: {
                        prefix: "+86",
                        dense: "",
                        outlined: "",
                        clearable: "",
                        "hide-details": "auto",
                        "validate-on-blur": "",
                        rules: [_vm.rules.required, _vm.rules.cn_phone],
                        required: "",
                      },
                      model: {
                        value: _vm.old_phone_number,
                        callback: function ($$v) {
                          _vm.old_phone_number = $$v
                        },
                        expression: "old_phone_number",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.showBtn
            ? _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab-item",
                    { attrs: { value: 1 } },
                    [
                      _c("v-form", { ref: "form_phone" }, [
                        _c(
                          "div",
                          { staticClass: "system-dialog__field" },
                          [
                            _c(
                              "div",
                              { staticClass: "system-dialog__label" },
                              [
                                _c("RequiredDot", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.showBtn
                                          ? _vm.$t("user.phone_number")
                                          : _vm.$t("old_phone[1]")
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c("NumberInput", {
                              staticClass: "bind-phone-number",
                              attrs: {
                                dense: "",
                                outlined: "",
                                "show-details": "",
                                rules: _vm.phoneRules,
                              },
                              model: {
                                value: _vm.phone_number,
                                callback: function ($$v) {
                                  _vm.phone_number = $$v
                                },
                                expression: "phone_number",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { attrs: { value: 2 } },
                    [
                      _c("v-form", { ref: "form_code" }, [
                        _c(
                          "div",
                          {
                            staticClass: "system-dialog__field bind-phone-code",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "system-dialog__label" },
                              [
                                _c("RequiredDot", [
                                  _vm._v(_vm._s(_vm.$t("tip_code[0]"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "bind-phone-code__row" },
                              [
                                _c("v-text-field", {
                                  staticClass:
                                    "system-dialog__input bind-phone-code__input",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    clearable: "",
                                    "hide-details": "auto",
                                    "validate-on-blur": "",
                                    rules: [_vm.rules.required, _vm.codeRule],
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.codeError = true
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "code", $$v)
                                    },
                                    expression: "formData.code",
                                  },
                                }),
                                !_vm.codeLoading
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "text-none bind-phone-code__btn",
                                        attrs: {
                                          depressed: "",
                                          small: "",
                                          outlined: "",
                                          color: "primary",
                                          loading: _vm.btnLoading,
                                        },
                                        on: { click: _vm.fetchCode },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("tip_code[1]")) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "text-none bind-phone-code__btn",
                                        attrs: {
                                          depressed: "",
                                          small: "",
                                          outlined: "",
                                          disabled: "",
                                          color: "primary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.codeTime + "s") +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("UpdateBillingInfo", { ref: "updateBillingInfo" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }